<div class="st-rundown-properties-content">
    <div class="st-rundown-properties-content-header">
        <st-text-area-overlay
            #slug
            required
            minRows="1"
            minHeight="1rem"
            class="st-rundown-properties-content-header__title"
            panelClass="st-rundown-properties-content-header__title"
            maxLength="50"
            disableNewLine
            maxOverlayRows="1"
            [label]="languageSettings().PSTAddRundownName"
            [placeholder]="languageSettings().PSTAddRundownName"
            [disabled]="rundownArchived()"
            [value]="title()"
            (changed)="updateRundown($event, PSTFieldNames.Title)" />
        <st-simple-search-box
            st-click-stop-propagation
            (searchThermChange)="onSearchTermHandler($event)" />
    </div>
    <!-- Properties -->
    <div class="st-rundown-properties-content-body">
        <mat-accordion
            class="st-rundown-properties-properties-accordion"
            displayMode="flat"
            togglePosition="before"
            multi>
            @for (group of groups(); track $index; let i = $index) {
                @if (groupedFields()[group]?.length > 0 && record()?.visibilityCriteriaGroups?.[group]) {
                    <mat-expansion-panel
                        #paneContainer
                        [class.st-rundown-properties-properties-accordion-pane-container-required]="enforceRequiredFieldsOnCreate() && !requiredFieldGroups()[group]"
                        [expanded]="i === 0">
                        <mat-expansion-panel-header class="st-expansion-panel-panel-header">
                            <mat-panel-title>{{ group }}</mat-panel-title>
                            <button
                                mat-icon-button
                                class="st-rundown-properties-properties-accordion-pane-container__expand-collapse"
                                st-click-stop-propagation
                                [matTooltip]="paneContainer?.expanded ? collapseAllLabel() : expandAllLabel()"
                                (click)="expandCollapseAll(paneContainer)">
                                <mat-icon fontSet="material-symbols-outlined">{{ paneContainer?.expanded ? 'collapse_all' : 'expand_all' }}</mat-icon>
                            </button>
                        </mat-expansion-panel-header>
                        <div class="st-rundown-properties-properties-accordion-pane-container-property-group">
                            @for (item of groupedFields()[group]; track $index; let j = $index) {
                                @if (item && record()?.visibilityCriteria?.[item?.ID]) {
                                    <div class="st-rundown-properties-properties-accordion-pane-container-property-container">
                                        <span class="st-rundown-properties-properties-accordion-pane-container-property__label">{{ item.DefaultCaption }}</span>
                                        @if (item.ID === PSTFieldNames.PSTSourceGUID) {
                                            <st-combo-box
                                                [required]="false"
                                                [value]="selectedRundownTemplate()"
                                                [itemList]="rundownTemplatesList()"
                                                (changed)="updateRundownTemplate($event)" />
                                        } @else if (item.ID === PSTFieldNames.RundownDuration) {
                                            <div>{{ duration() }}</div>
                                        } @else if (item.ID === PSTFieldNames.ScriptTemplate) {
                                            <st-combo-box
                                                [disabled]="localRecord()?.readOnlyCriteria?.[item.ID] || rundownArchived()"
                                                [required]="false"
                                                [value]="selectedStoryTemplate()"
                                                [itemList]="storyTemplatesList()"
                                                (changed)="updateRundown($event?.id, item.ID)" />
                                        } @else {
                                            @switch (item.Validation?.toUpperCase()) {
                                                @case (FieldDefValidations.TEXT) {
                                                    @if (item.WordWrap) {
                                                        <st-text-area
                                                            showLinks
                                                            [disabled]="item?.ReadOnlyValue || localRecord()?.readOnlyCriteria?.[item.ID] || rundownArchived()"
                                                            [required]="item.Required"
                                                            [tabindex]="j"
                                                            [placeholder]="item.DefaultCaption"
                                                            [value]="localRecord()?.[item.ID]"
                                                            (changed)="valueChanged($event, item.ID)" />
                                                    } @else {
                                                        <st-text-field
                                                            showLinks
                                                            [disabled]="item?.ReadOnlyValue || localRecord()?.readOnlyCriteria?.[item.ID] || rundownArchived()"
                                                            [required]="item.Required"
                                                            [tabindex]="j"
                                                            [placeholder]="item.DefaultCaption"
                                                            [value]="localRecord()?.[item.ID]"
                                                            (changed)="valueChanged($event, item.ID)" />
                                                    }
                                                }
                                                @case (FieldDefValidations.NUMBER) {
                                                    <st-text-field
                                                        showLinks
                                                        type="number"
                                                        [disabled]="item?.ReadOnlyValue || localRecord()?.readOnlyCriteria?.[item.ID] || rundownArchived()"
                                                        [required]="item.Required"
                                                        [tabindex]="j"
                                                        [placeholder]="item.DefaultCaption"
                                                        [value]="localRecord()?.[item.ID]"
                                                        (changed)="valueChanged($event, item.ID)" />
                                                }
                                                @case (FieldDefValidations.COMBOBOX) {
                                                    <st-combo-box
                                                        [disabled]="item?.ReadOnlyValue || localRecord()?.readOnlyCriteria?.[item.ID] || rundownArchived()"
                                                        [required]="item.Required"
                                                        [tabindex]="j"
                                                        [placeholder]="item.DefaultCaption"
                                                        [addEmptyOption]="!item.Required"
                                                        [value]="localRecord()?.[item.ID]"
                                                        [itemList]="globalTablesService.getListItems(item.ID, item.List)"
                                                        (changed)="valueChanged($event, item.ID)" />
                                                }
                                                @case (FieldDefValidations.CHECKLIST) {
                                                    <st-check-list
                                                        [disabled]="item?.ReadOnlyValue || localRecord()?.readOnlyCriteria?.[item.ID] || rundownArchived()"
                                                        [required]="item.Required"
                                                        [tabindex]="j"
                                                        [placeholder]="item.DefaultCaption"
                                                        [value]="localRecord()?.[item.ID]"
                                                        [data]="localRecord()"
                                                        [fieldName]="item.ID"
                                                        [itemList]="globalTablesService.getListItems(item.ID, item.List)"
                                                        (changed)="valueChanged($event, item.ID)" />
                                                }
                                                @case (FieldDefValidations.CHECKBOX) {
                                                    <st-check-box
                                                        [disabled]="item?.ReadOnlyValue || localRecord()?.readOnlyCriteria?.[item.ID] || readonlyProps().get(item.ID) || rundownArchived()"
                                                        [tabindex]="j"
                                                        [placeholder]="item.DefaultCaption"
                                                        [value]="localRecord()?.[item.ID]"
                                                        (changed)="checkboxValueChanged($event, item.ID)" />
                                                }
                                                @case (FieldDefValidations.DATE) {
                                                    <st-date-picker
                                                        [disabled]="item?.ReadOnlyValue || localRecord()?.readOnlyCriteria?.[item.ID] || rundownArchived()"
                                                        [required]="item.Required"
                                                        [tabindex]="j"
                                                        [placeholder]="item.DefaultCaption"
                                                        [value]="localRecord()?.[item.ID]"
                                                        (changed)="valueChanged($event, item.ID)" />
                                                }
                                                @case (FieldDefValidations.TIME) {
                                                    <st-date-time-picker
                                                        [disabled]="isTimeFieldDisabled(item)"
                                                        [required]="item.Required"
                                                        [tabindex]="j"
                                                        [min]="item.ID === PSTFieldNames.PSTRundownEndTime ? rundownMinDate() : null"
                                                        [placeholder]="item.DefaultCaption"
                                                        [value]="localRecord()?.[item.ID]"
                                                        (timezoneChange)="timezoneChanged(item.ID, $event)"
                                                        (changed)="valueChanged($event, item.ID)" />
                                                }
                                                @case (FieldDefValidations.MOSDATETIME) {
                                                    <st-date-time-picker
                                                        [disabled]="item?.ReadOnlyValue || localRecord()?.readOnlyCriteria?.[item.ID] || rundownArchived()"
                                                        [required]="item.Required"
                                                        [tabindex]="j"
                                                        [placeholder]="item.DefaultCaption"
                                                        [value]="localRecord()?.[item.ID]"
                                                        (timezoneChange)="timezoneChanged(item.ID, $event)"
                                                        (changed)="valueChanged($event, item.ID)" />
                                                }
                                                @case (FieldDefValidations.DATETIMERANGE) {
                                                    <st-date-time-range
                                                        [placeholder]="item.DefaultCaption"
                                                        [disabled]="item?.ReadOnlyValue || localRecord()?.readOnlyCriteria?.[item.ID] || rundownArchived()"
                                                        [required]="item.Required"
                                                        [tabindex]="j"
                                                        [value]="localRecord()?.[item.ID]"
                                                        (changed)="valueChanged($event, item.ID)" />
                                                }
                                                @case (FieldDefValidations.STAFFIDLIST) {
                                                    <st-staff-id-list-multiple
                                                        [disabled]="item?.ReadOnlyValue || localRecord()?.readOnlyCriteria?.[item.ID] || rundownArchived()"
                                                        [required]="item.Required"
                                                        [tabindex]="j"
                                                        [placeholder]="item.DefaultCaption"
                                                        [value]="localRecord()?.[item.ID]"
                                                        (changed)="valueChanged($event, item.ID)" />
                                                }
                                                @case (FieldDefValidations.TREE) {
                                                    <st-tree
                                                        [disabled]="item?.ReadOnlyValue || localRecord()?.readOnlyCriteria?.[item.ID] || rundownArchived()"
                                                        [required]="item.Required"
                                                        [tabindex]="j"
                                                        [placeholder]="item.DefaultCaption"
                                                        [value]="localRecord()?.[item.ID]"
                                                        [itemList]="globalTablesService.getlistItemsForTree(item.List)"
                                                        [addEmptyOption]="!item.Required"
                                                        (changed)="valueChanged($event, item.ID)" />
                                                }
                                                @case (FieldDefValidations.ADDRESS) {
                                                    <st-address-form
                                                        [required]="item.Required"
                                                        [tabindex]="j"
                                                        [disabled]="item?.ReadOnlyValue || localRecord()?.readOnlyCriteria?.[item.ID] || rundownArchived()"
                                                        [placeholder]="item.DefaultCaption"
                                                        [value]="localRecord()?.[item.ID]"
                                                        (changed)="valueChanged($event, item.ID)" />
                                                }
                                                @case (FieldDefValidations.MOSDURATION) {
                                                    <st-duration-seconds-input-field
                                                        [disabled]="item?.ReadOnlyValue || localRecord()?.readOnlyCriteria?.[item.ID] || rundownArchived()"
                                                        [required]="item.Required"
                                                        [tabindex]="j"
                                                        [placeholder]="item.DefaultCaption"
                                                        [value]="localRecord()?.[item.ID]"
                                                        (changed)="valueChanged($event, item.ID)" />
                                                }
                                            }
                                        }
                                    </div>
                                }
                            }
                        </div>
                    </mat-expansion-panel>
                }
            }
        </mat-accordion>
    </div>
</div>
